import { EnrichmentPlugin, Event } from '@amplitude/analytics-browser/lib/esm/types'

export const addEventMetaPlugin = ({ orgId, routeId }: { orgId: string | undefined, routeId: string | undefined }): EnrichmentPlugin => ({
  execute: async (event: Event) => {
    event.groups = {
      ...event.groups,
      organization: orgId,
    }
    event.event_properties = {
      ...event.event_properties,
      app_name: 'Portal',
      route: routeId,
    }
    return event
  },
})